import {Textarea as NextUITextarea, TextAreaProps as NextUITextAreaProps} from "@heroui/react";

interface TextAreaProps extends NextUITextAreaProps {
}

export const Textarea = ({...props}: TextAreaProps) => {
  return (
    <NextUITextarea {...props}/>
  )
}

